var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poster"},[[_c('el-row',_vm._l((_vm.imgSrc),function(item,index){return _c('el-col',{key:index,staticClass:"img",attrs:{"span":index < _vm.imgSrc.length - 1 && _vm.imgSrc.length == 4
            ? 8
            : index < _vm.imgSrc.length - 1 && _vm.imgSrc.length == 3
            ? 12
            : _vm.imgSrc.length - 1 && _vm.imgSrc.length == 2
            ? 12
            : 24}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('img',{staticClass:"auto-img",attrs:{"src":item.imageUrl}})])])}),1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }